<template>
  <v-dialog
    v-model="dialog"
    width="560"
    :aria-label="t('appPromo.dialog.title')"
  >
    <v-card class="cc-app-promo-dialog">
      <v-card-title class="d-flex align-center">
        <v-icon
          class="mr-3"
          :icon="Icons.CELLPHONE_ARROW_DOWN"
        />
        <span>{{ t('appPromo.dialog.title') }}</span>
      </v-card-title>

      <v-card-text>
        <p class="text-body-1 mb-4">
          {{ t('appPromo.dialog.text') }}
        </p>
        <cc-app-store-links class="mb-4" />
        <p class="text-body-2 text-medium-emphasis text-center">
          {{ t('appPromo.dialog.hint') }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="dialog = false"
        >
          {{ t('appPromo.dialog.later') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
//================= [CSS] =====================================

//================= [JS] ======================================
import {Icons} from '@simpleforyou/client-core';
import {useAppPromo} from '@/composables/useAppPromo';
//================= [VUE COMPONENTS] ==========================
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import CcAppStoreLinks from '@/components/common/CcAppStoreLinks.vue';

const {t} = useI18n();
const {promoVisible, dialogSeen, markDialogSeen} = useAppPromo();

const dialog = ref(false);

// Marked as seen the moment it opens, not when it is closed: a reload or a
// navigation away is an answer too, and asking again in the same session would
// make it feel like the app is nagging.
onMounted(() => {
  if (!promoVisible.value || dialogSeen()) {
    return;
  }
  markDialogSeen();
  dialog.value = true;
});
</script>
